import React__default, { memo } from 'react';

const ButtonLoader = /*#__PURE__*/ memo(()=>/*#__PURE__*/ React__default.createElement("div", {
        "aria-hidden": "true",
        className: "button--loader"
    })
);
var ButtonLoader$1 = ButtonLoader;

export { ButtonLoader$1 as default };
//# sourceMappingURL=ButtonLoader.js.map
